import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LetterTemplateDataModel} from '../models/letters/letter-template-data.model';

@Injectable({
  providedIn: 'root'
})
export class LettersService {

  constructor(private http: HttpClient) {
  }

  getTemplates() {
    return this.http.get<LetterTemplateDataModel[]>(`api/letters/get-templates`);
  }

  getDeliveryOptions(templateId: string) {
    //return this.http.get
  }
}
